import Styles from "./NavigationBar.module.scss";
import classnames from "classnames"

//Icons
import {ReactComponent as BackIcon} from "../../../icons/extra_icons/samsung_back.svg"
import {ReactComponent as HomeIcon} from "../../../icons/extra_icons/samsung_home.svg"
import {ReactComponent as AppsIcon} from "../../../icons/extra_icons/navigation_all_apps.svg"
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { closeWindow, handleDisableTaskView, handleToggleTaskView } from "../../../actions";
import handleTaskView from "../../../reducers/taskView";

interface NavigationBarProps {
    appId: string;
    forceDarkMode?:boolean;
    onBackClick?:()=>void;
    onSuccessfullyClosed?:(data?:any)=>void;
}
const NavigationBar = ({ appId,forceDarkMode=false ,onBackClick, onSuccessfullyClosed }: NavigationBarProps) => {

    const dispatch = useDispatch()

    const isTaskViewEnabled = useSelector((state:RootStateOrAny)=>state.handleTaskView)

    const handleCloseClick=()=>{
        if(onBackClick){
            onBackClick()
        }
        else{
            dispatch(closeWindow(appId))
            onSuccessfullyClosed?.()
        }
    }

    const handleTaskViewClick = (e:any)=>{
        e.stopPropagation()
        dispatch(handleToggleTaskView())
    }

    const handleHomeClick = () => {
        if(isTaskViewEnabled){
            dispatch(handleDisableTaskView())
        }
        else{
            dispatch(closeWindow(appId))
        }
    }

    return (
        <div className={classnames(Styles.container,forceDarkMode && Styles.forced_dark)}  >
            <div className={Styles.button} onClick={handleTaskViewClick}>
                <AppsIcon/>
            </div>
            <div className={Styles.button} onClick={handleHomeClick}>
                <HomeIcon/>
            </div>
            <div className={Styles.button} onClick={handleCloseClick}>
                <BackIcon/>
            </div>
        </div>
    )
}

export default NavigationBar
